export default function getVehiclePrimaryText(_a) {
    var make = _a.make, model = _a.model;
    return [make === null || make === void 0 ? void 0 : make.name, model === null || model === void 0 ? void 0 : model.name]
        .filter(function (name) { return typeof name === "string"; })
        .join(" ");
}
